var _rect, _rect2, _defs, _rect3, _circle, _circle2, _circle3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 312,
    viewBox: "0 0 223 312",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 223,
    height: 312,
    rx: 10,
    ry: 10,
    fill: "#1e3a8a",
    stroke: "#1e40af",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 183,
    height: 272,
    rx: 8,
    ry: 8,
    fill: "#3b82f6",
    stroke: "#1d4ed8",
    strokeWidth: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "cardPattern",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3,
    fill: "#1e40af",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 1,
    fill: "#ffffff",
    opacity: 0.5
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 163,
    height: 252,
    fill: "url(#cardPattern)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 156,
    r: 40,
    fill: "#1e40af",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 156,
    r: 30,
    fill: "#1e40af",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 156,
    r: 20,
    fill: "#1e40af",
    opacity: 0.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 50,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#ffffff",
    opacity: 0.8
  }, "\u2660")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 193,
    y: 262,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#ffffff",
    opacity: 0.8,
    transform: "rotate(180 193 262)"
  }, "\u2660")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBack);
export default __webpack_public_path__ + "static/media/BLUE_BACK.bf929072b7eb404c7d8ccfae125896f9.svg";
export { ForwardRef as ReactComponent };